import React from "react";

// Mascotte-nucleo Fuma: orb vivo con faccina, glow profondo, anelli + particelle + satelliti
// orbitanti e fumetto. mode: idle | listening | processing | speaking | success.
export default function FumaCore({ mode = "idle" }) {
  const showBubble = mode === "idle" || mode === "success";
  return (
    <div className={`fuma-core mode-${mode}`} data-testid="fuma-core" data-mode={mode} aria-hidden>
      <span className="halo" />
      <span className="ring r1" />
      <span className="ring r2" />
      <span className="ring r3" />
      <span className="particles">
        {Array.from({ length: 7 }).map((_, i) => <i key={i} style={{ "--d": `${i * 51}deg` }} />)}
      </span>
      <span className="core">
        <span className="fuma-face"><i className="eye l" /><i className="eye r" /><i className="mouth" /></span>
      </span>
      <span className="scan" />
      <span className="sat sat-a" data-testid="fuma-sat-food">🍕</span>
      <span className="sat sat-b" data-testid="fuma-sat-heart">❤️</span>
      <span className="sat sat-c" data-testid="fuma-sat-pin">📍</span>
      {showBubble && <span className="fuma-bubble" data-testid="fuma-bubble">Ci penso io ✨</span>}
    </div>
  );
}
